import { FileDownloadButton, TabPanel } from '@/components';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { FormUsersUpload, UsersUploadFailedModal } from '@/views';
import { usersHttp } from '@/core';
import { useState } from 'react';

export function UsersUploadPanel() {
  const { t } = useTranslation();
  const [errors, setErrors] = useState<string[]>();

  return (
    <TabPanel min="auto">
      <TabPanel.Title>{t('users.upload.title')}</TabPanel.Title>
      <TabPanel.Body>
        <Row>
          <FileDownloadButton
            className="mb-3"
            download="download"
            name={t('users.upload.downloadSample')}
            action={() => usersHttp.downloadUploadSample()}
            type="link"
          />
        </Row>
        <Row>
          <Col span={6}>
            <FormUsersUpload onUploadFailed={setErrors} />
          </Col>
        </Row>
        {errors && (
          <UsersUploadFailedModal
            errorPayload={errors}
            onClose={() => setErrors(undefined)}
          />
        )}
      </TabPanel.Body>
    </TabPanel>
  );
}
